module.exports = __webpack_public_path__ + "static/media/Jam5.bd789d58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/Jam5.svg
// module id = 606
// module chunks = 0